export default "__VITE_ASSET__CkzOuSHd__"